import firebaseService from 'utils/firebase/firebase';

export const logScreenView = async (screen) => {
  await firebaseService.analytics().setCurrentScreen(screen);
};

export const logEvent = async (name, params = {}) => {
  await firebaseService.analytics().logEvent(name, params);
};

export const setUserProperties = async (properties) => {
  await firebaseService.analytics().setUserProperties(properties);
};

// Welcome/Tutorial Video Analytics
export const trackWelcomeVideoCompleted = async (params = {}) => {
  await logEvent('welcome_video_completed', params);
};

export const trackWelcomeVideoClosed = async (params = {}) => {
  await logEvent('welcome_video_closed', params);
};

export const trackTutorialFlowCompleted = async (params = {}) => {
  await logEvent('tutorial_flow_completed', params);
};

export const trackTutorialFlowClosed = async (params = {}) => {
  await logEvent('tutorial_flow_closed', params);
};